exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".login[data-v-7e0a7208] {\n  position: fixed;\n  z-index: 9999;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n  margin: 0;\n  padding: 0;\n  background: url(/images/background_login.jpg) no-repeat center fixed;\n  background-size: cover;\n}\n.login .login-row[data-v-7e0a7208] {\n  height: 100%;\n  background: rgba(0, 0, 0, 0.4);\n}", ""]);

// exports
